// extracted by mini-css-extract-plugin
module.exports = {"loader":"orders_loader__2Xb1q","cardHeader":"orders_cardHeader__3MBYg","eyeicon":"orders_eyeicon__10oz2"};